import './public-path';
import React from 'react';
import ReactDOM from 'react-dom';
import * as smoothscroll from 'smoothscroll-polyfill';
import { setupTracer } from './tracer';
import App from './routers';

// Addinng trace to launch file(index.tsx) makes it available in the application for use
if (process.env.NODE_ENV !== 'development') {
  setupTracer();
}

smoothscroll.polyfill();

const logger = console;
const render = (props) => {
  const { container = document.body } = props;
  const mountedNode = container.querySelector('#app');
  ReactDOM.render(<App container={container} />, mountedNode);
};

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  logger.log('react app bootstraped');
}

export async function mount(props) {
  if (!window.conviva || !window.conviva.microProps) {
    Object.defineProperty(window.conviva, 'microProps', {
      value: props,
      writable: false,
    });
  }
  render(props);
}

export async function unmount() {
  const $app = document.getElementById('app');
  if ($app) {
    ReactDOM.unmountComponentAtNode($app);
  }
}

export async function update(props) {
  logger.log('update props', props);
}
